import { FC } from "react";
import { IPageProps } from "./types.app";
import { LoadingIndicator, LoaderTypeEnums } from "@canei/app-components";
import { Private } from "../views/local/Private";
import { Public } from "../views/local/Public";

export const ElectronApp: FC<IPageProps> = ({ loading, authenticated }) => {
  if (loading) return <LoadingIndicator type={LoaderTypeEnums.PAGE} />;
  return authenticated ? <Private /> : <Public />;
};
